// Tabs shared by the organisation pages (people and plan & billing).
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export function OrganizationNav() {
  const { t } = useTranslation();
  return (
    <nav aria-label={t('organization.nav')} className="account-tabs">
      <Link to="/organization">{t('organization.navMembers')}</Link>
      <Link to="/organization/billing">{t('organization.navBilling')}</Link>
    </nav>
  );
}
